import React from "react";

export default function TabsBar({ tabs, active, onChange }) {
  return (
    <div className="no-scrollbar overflow-x-auto">
      <div className="inline-flex gap-2 rounded-xl border border-gray-100 bg-white p-1 shadow-sm">
        {tabs.map(({ key, label, icon: Icon }) => {
          const isActive = active === key;
          return (
            <button
              key={key}
              onClick={() => onChange(key)}
              className={
                "inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm " +
                (isActive ? "bg-emerald-600 text-white" : "text-gray-700 hover:bg-gray-50")
              }
            >
              {Icon ? <Icon size={16} /> : null}
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
